import { render } from "./ComponentQuickNote.vue?vue&type=template&id=cdf4fad6&scoped=true"
import script from "./ComponentQuickNote.vue?vue&type=script&lang=js"
export * from "./ComponentQuickNote.vue?vue&type=script&lang=js"

import "./ComponentQuickNote.vue?vue&type=style&index=0&id=cdf4fad6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdf4fad6"]])

export default __exports__